import React from 'react';
import { SparklesIcon, HeartIcon, SunIcon, DropletIcon } from 'lucide-react';
interface BrandShopByCategoryProps {
  brandSlug: string;
}
export function BrandShopByCategory({
  brandSlug
}: BrandShopByCategoryProps) {
  const categories = [{
    id: 1,
    name: 'Face Care',
    icon: <SparklesIcon className="w-6 h-6" data-id="element-1486" data-mp="347ic5ouxlnz0" />,
    color: 'from-pink-500 to-rose-500',
    productCount: 45
  }, {
    id: 2,
    name: 'Body Care',
    icon: <HeartIcon className="w-6 h-6" data-id="element-1487" data-mp="3i1hzqsgiuj7i" />,
    color: 'from-purple-500 to-indigo-500',
    productCount: 32
  }, {
    id: 3,
    name: 'Sun Protection',
    icon: <SunIcon className="w-6 h-6" data-id="element-1488" data-mp="3rx2wab2tmr9v" />,
    color: 'from-orange-500 to-yellow-500',
    productCount: 28
  }, {
    id: 4,
    name: 'Hydration',
    icon: <DropletIcon className="w-6 h-6" data-id="element-1489" data-mp="1xj1zdvqu0ecf" />,
    color: 'from-blue-500 to-cyan-500',
    productCount: 38
  }];
  return <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1490" data-mp="1slsb4jf6i8q6">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-1491" data-mp="2nfcmtqlk4gy1">
        Shop by Category
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-1492" data-mp="2sdnwo1buqrg9">
        {categories.map(category => <div key={category.id} className="relative rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all cursor-pointer group" data-id="element-1493" data-mp="2wfixz5ts94u1">
            <div className={`bg-gradient-to-br ${category.color} p-4 md:p-6 text-white`} data-id="element-1494" data-mp="365udzqqqr4ha">
              <div className="flex flex-col items-center text-center" data-id="element-1495" data-mp="3b3vwoak991s8">
                <div className="bg-white bg-opacity-20 p-3 md:p-4 rounded-xl mb-2 md:mb-3 group-hover:scale-110 transition-transform" data-id="element-1496" data-mp="3g3s12awv6v8b">
                  {category.icon}
                </div>
                <h3 className="font-bold text-sm md:text-lg mb-1" data-id="element-1497" data-mp="3k30t9bc9al1r">
                  {category.name}
                </h3>
                <p className="text-xs md:text-sm text-white text-opacity-90" data-id="element-1498" data-mp="1pqstnkozpfzn">
                  {category.productCount} Products
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}